import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
function getVarName(variable) {
    var matches = variable.match(/^var\((.*)\)$/);
    if (matches) {
        var _matches_;
        return (_matches_ = matches[1]) !== null && _matches_ !== void 0 ? _matches_ : variable;
    }
    return variable;
}
export function assignInlineVars(vars) {
    var styles = {};
    for(var varName in vars){
        var value = vars[varName];
        if (value == null) {
            continue;
        }
        styles[getVarName(varName)] = value;
    }
    return styles;
}
export function mapResponsivePropToCSSVars(responsiveProp, cssVars) {
    // assign CSS vars
    var vars = {};
    var classes = [];
    if (isResponsiveProp(responsiveProp)) {
        vars[cssVars.mobileAndAbove.variable] = responsiveProp.mobileAndAbove;
        classes.push(cssVars.mobileAndAbove.className);
        if (cssVars.tabletAndAbove && responsiveProp.tabletAndAbove) {
            vars[cssVars.tabletAndAbove.variable] = responsiveProp.tabletAndAbove;
            classes.push(cssVars.tabletAndAbove.className);
        }
        if (cssVars.desktopAndAbove && responsiveProp.desktopAndAbove) {
            vars[cssVars.desktopAndAbove.variable] = responsiveProp.desktopAndAbove;
            classes.push(cssVars.desktopAndAbove.className);
        }
        if (cssVars.xLargeAndAbove && responsiveProp.xLargeAndAbove) {
            vars[cssVars.xLargeAndAbove.variable] = responsiveProp.xLargeAndAbove;
            classes.push(cssVars.xLargeAndAbove.className);
        }
        if (cssVars.xxLargeDesktop && responsiveProp.xxLargeDesktop) {
            vars[cssVars.xxLargeDesktop.variable] = responsiveProp.xxLargeDesktop;
            classes.push(cssVars.xxLargeDesktop.className);
        }
    } else {
        vars[cssVars.mobileAndAbove.variable] = responsiveProp;
        classes.push(cssVars.mobileAndAbove.className);
    }
    return {
        vars: vars,
        classes: classes
    };
}
